import { landingAssets } from 'assets/landing'
import { logos } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing.css */
  .section_heading {
    font-size: 1.1rem;
    font-weight: 300;
    text-transform: uppercase;
    width: 900%;
    padding: 5px 30px 10px 0;
  }
  &.landing_level {
    width: 90%;
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    position: relative;
    z-index: 0;
    padding: 15px 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  &.landing_level .section_heading {
    text-align: center;
  }
  &.landing_level.investors {
    background: hsla(0, 0%, 0%, 0.3);
    border-top: 0;
    margin: 50px 0 0 0;
    border-radius: 10px;
    padding: 30px;
  }
  &.landing_level .logos {
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
  }
  &.landing_level a {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px 0 0 0;
  }
  &.landing_level a .logo {
    height: 50px;
  }
  &.landing_level a.pantera .logo {
    background: url(${landingAssets.pantera_cap_logo_color_circle}) center center / auto 40px no-repeat;
    width: 40px;
  }
  &.landing_level a.cluster .logo {
    background: url(${landingAssets.cluster_color_circle}) center center / auto 40px no-repeat;
    width: 40px;
  }
  &.landing_level a.lemniscap .logo {
    background: url(${landingAssets.lemniscap_logo_color}) center center / auto 30px no-repeat;
    width: 150px;
  }
  &.landing_level a.deepventures .logo {
    background: url(${landingAssets.deepventures_color_circle}) center center / auto 50px no-repeat;
    width: 50px;
  }
  &.landing_level a.angeldao .logo {
    background: url(${landingAssets.angeldao_logo_color}) center center / auto 35px no-repeat;
    width: 140px;
  }
  &.landing_level a.kretos .logo {
    background: url(${landingAssets.kretos_logo}) center center / auto 40px no-repeat;
    width: 40px;
  }
  &.landing_level a .logo {
    width: 100%;
  }
  &.landing_level a span {
    visibility: hidden;
    text-align: center;
    width: 100%;
    font-size: 0.8rem;
    line-height: 130%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  &.landing_level a:hover span {
    visibility: hidden;
  }
  @media (max-width: 1250px) {
    .section_heading {
      width: 90%;
    }
  }
  @media (max-width: 800px) {
    .section_heading {
      width: 95%;
    }
  }
`

const developerCSS = css``

export const InvestorsSectionCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
